import { FlexBox, FormulaKeyButton } from 'components/atoms'
import { useBetContext } from 'contexts/BetContext'
import { useTranslation } from 'contexts/TranslationContext'
import { TFormulaKey } from 'models/betTypes'

export const FormulaKeySelector = () => {
    const { selectedFormulaKey, setSelectedFormulaKey, handleTrackingEvent } =
        useBetContext()
    const translation = useTranslation()

    const handleClick = (actionType: TFormulaKey) => {
        setSelectedFormulaKey(actionType)
        void handleTrackingEvent({
            eventType: 'FORMULA_KEY',
            actionType
        })
    }
    return (
        <FlexBox
            sx={{
                gap: 1,
                justifyContent: 'space-between',
                width: '100%',
                mt: 2
            }}
        >
            <FormulaKeyButton
                title={`${translation.unit} /\n${translation.combined}`}
                selected={selectedFormulaKey === 'UNIT'}
                onClick={() => handleClick('UNIT')}
            />
            <FormulaKeyButton
                title={translation.partWheel.replace(' ', '\n')}
                selected={selectedFormulaKey === 'PART_WHEEL'}
                onClick={() => handleClick('PART_WHEEL')}
            />
            <FormulaKeyButton
                title={translation.totalWheel.replace(' ', '\n')}
                selected={selectedFormulaKey === 'WHEEL'}
                onClick={() => handleClick('WHEEL')}
            />
        </FlexBox>
    )
}
